import * as yup from "yup";
import { ApplicationResource } from "@/api/generated-api";

export const yupFeedbackSchema: yup.ObjectSchema<ApplicationResource> = yup.object().shape({
  name: yup.string().required("Введите имя"),
  phone: yup.string().length(18, "Некорректный номер телефона"),
  email: yup.string().email("Введите email").required("Введите email"),
  city: yup.string(),
  message: yup.string().required("Введите сообщение"),
});
